import { render, staticRenderFns } from "./aviso-planificaciones-abiertas.vue?vue&type=template&id=907a66e8&scoped=true"
import script from "./aviso-planificaciones-abiertas.vue?vue&type=script&lang=js"
export * from "./aviso-planificaciones-abiertas.vue?vue&type=script&lang=js"
import style0 from "./aviso-planificaciones-abiertas.vue?vue&type=style&index=0&id=907a66e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a66e8",
  null
  
)

export default component.exports